/**
 * UI-6b Task 12 — ActiveCallsCounter widget manifest.
 *
 * Phase 1 PLACEHOLDER — see Renderer.tsx.
 */
import { registerWidget } from '../registry.js'
import type { WidgetManifest } from '../types.js'
import {
  ActiveCallsCounterRenderer,
  type ActiveCallsCounterConfig,
} from './Renderer.js'
import { ActiveCallsCounterConfigEditor } from './ConfigEditor.js'

export const activeCallsCounterManifest: WidgetManifest<ActiveCallsCounterConfig> = {
  type: 'active-calls-counter',
  label: 'Active Calls',
  description: 'Live count of in-progress calls (Phase 1: placeholder).',
  defaultSize: '1x1',
  defaultConfig: {} as ActiveCallsCounterConfig,
  Renderer: ActiveCallsCounterRenderer,
  ConfigEditor: ActiveCallsCounterConfigEditor,
}

registerWidget(activeCallsCounterManifest)
